import React, { createContext, useState } from 'react';

export interface IProgressContext
{
    progressBarStep: number,
    progressForward: () =>  void,
    progressBackward: () => void,
    resetProgress: () => void
}

export const ProgressContext = createContext<IProgressContext | null>(null);

export const ProgressProvider: React.FunctionComponent = ({ children }) => 
{
    const [ progressBarStep, setProgressBarStep ] = useState<number>(0);

    const progressForward = () =>
    {
        setProgressBarStep(progressBarStep + 1);
    };

    const progressBackward = () =>
    {
        setProgressBarStep(progressBarStep - 1);
    };

    const resetProgress = () =>
    {
        setProgressBarStep(0);
    };

    const progressContext = {
        progressBarStep, progressForward, progressBackward, resetProgress
    };

    return (
        <ProgressContext.Provider value={progressContext}>{children}</ProgressContext.Provider>
    );
};
